import React from 'react';
import { DataTypeProvider } from '@devexpress/dx-react-grid';
import { serviceActivityStatusOptions } from '../_Utils/AppDocuCommon';

const StatusFormatter = ({ value }) => {
  const found = serviceActivityStatusOptions.find(opt => opt.name === value);
  if (!found) {
    return <span style={{ color: '#222' }}>{value || ''}</span>;
  }
  const color = found.color;
  return (
    <span style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
      <span style={{
        display: 'inline-block',
        width: 14,
        height: 14,
        borderRadius: '50%',
        background: color,
        marginRight: 2,
        border: '1.5px solid #bbb',
      }} />
      <span style={{ position: 'relative', top: 2, fontWeight: 'bold' }}>{value || ''}</span>
    </span>
  );
};

const StatusTypeProvider = props => <DataTypeProvider formatterComponent={StatusFormatter} {...props} />;

export default StatusTypeProvider;
